import { OS, getOS } from "common/utils/context";
import * as THREE from "three";
import type { DepthTextureType } from "./threejs/higharc/DepthTextureType";
import { testDepthTextureBitDepth } from "./threejs/higharc/testDepthTextureBitDepth";

interface WebGLExtendedCapabilitiesParams {
  renderer: THREE.WebGLRenderer;
}

/**
 * This class fills in some things missing from three.js core WebGL capabilities checks.
 */
export class WebGLExtendedCapabilities {
  readonly depthTexturesSupported: boolean;
  readonly intDepthTextureIsPrecise: boolean;
  readonly defaultDepthTextureType: DepthTextureType;

  readonly supportsHalfFloatRenderTargetAndLinearSampling: boolean;
  readonly supportsFloatRenderTarget: boolean;

  readonly defaultEnableViewZConversion: boolean;

  constructor({ renderer }: WebGLExtendedCapabilitiesParams) {
    this.depthTexturesSupported = true; // Always supported on WebGL 2.0.
    this.defaultDepthTextureType = 0;
    this.intDepthTextureIsPrecise = false;
    if (this.depthTexturesSupported) {
      this.intDepthTextureIsPrecise = testDepthTextureBitDepth(renderer, THREE.UnsignedIntType);
      if (this.intDepthTextureIsPrecise) {
        this.defaultDepthTextureType = THREE.UnsignedIntType;
      }
    }

    const disableViewZConversion = getOS() === OS.IPHONE; // Save memory on iPhone
    this.defaultEnableViewZConversion = !disableViewZConversion;

    this.supportsHalfFloatRenderTargetAndLinearSampling = renderer.extensions.has("EXT_color_buffer_half_float");
    this.supportsFloatRenderTarget = renderer.extensions.has("EXT_color_buffer_float");
  }
}
